<form name="frmCountryCodeConfiguration"  style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;min-height:80vh;background-color: #f4f8f6;">
        <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px;background :linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white;">Country Code Configuration</div>
        <div class="panel-body">
            <div class="activity-box" *ngIf="dataLoader"><div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load"/></div></div>
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-12">
                    <div class="col-sm-3 formdivcaptions" style="width:auto;margin-top:30px;">
                        <label style="color:black;font-weight:bold;margin-right:30px;">Device Type</label>
                        <label *ngFor="let DeviceType of DeviceTypeList">
                            <input type="radio" name="radioDeviceType" value="{{DeviceType.name}}"
                                (change)="DeviceTypeEvent($event)" /><label>&nbsp;{{DeviceType.name}}&nbsp; </label>
                        </label>
                    </div>                 
                </div>
                <div class="col-sm-12">
                    <div id="divCountryCodeCommon" style="display:none;">
                        <div class="col-sm-3 formDivCaptions">
                            <label for="dlstCountry">Country</label>
                            <select class="form-control col-sm-4" id="dlstCountry" name="dlstCountry">
                                <option value="">&lt;--Select--&gt;</option>
                                <option  *ngFor="let C of Countries">{{C.Country}}</option>
                            </select>
                        </div>
                        <div class="col-sm-3 formDivCaptions">
                            <label for="dlstUseCase">Use Case</label>
                            <select class="form-control col-sm-4" id="dlstUseCase" name="dlstUseCase">
                                <option value="">&lt;--Select--&gt;</option>
                                <option  *ngFor="let UseCase of UseCaseList" value="{{UseCase.Value}}">{{UseCase.Value}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-6 formdivcaptions" style="margin-top:2%;">
                        <div align="left" id="divCountryCodeSubmit" style="display:none;">
                            <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span> Search</button>                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" *ngIf="Country=='India' && Device == 'Cisco'" id="btnExcelExport" class="btn btn-default btn-group-sm Button1" (click)="ExportToBulkExcel()"><span class="glyphicon glyphicon-export" aria-hidden="true"></span> Export to Excel</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
     
        <div class="row" id="divCountryCodeDetails" style="display:none;">
            <div style=" margin-left:20px; margin-right:20px;">
              
                <table id="CallrateDetails" class="table table-bordered" border="1" style="margin-left:2.7%;width:80%;font-size:13px;">
                    <tr style="color:white;background: #8064A2; height:25px; background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                        <th style="display:none">S.No</th>
                        <th style="text-align: center;"></th>
                        <th style="text-align: center;">Country</th>
                        <th style="text-align: center;">Country Code</th>
                        <th style="text-align: center;">Facility Type</th>
                        <th style="text-align: center;">Use Case</th>
                    </tr>

                    <tbody  *ngFor="let countryCodeConfiguration of successfulData.countryCodeConfigurations">
                        <tr *ngIf="countryCodeConfiguration.Id != this.successfulData.selected.Id">
                            <td style="display:none">{{countryCodeConfiguration.Id}}</td>
                            <td>
                                <img src="assets/img/Edit-icon.png" title="Edit" (click)="EditCountryCode(countryCodeConfiguration)" />
                                <img src="assets/img/Delete.png" title="Delete" (click)="DeleteCountryCode(countryCodeConfiguration)" />
                            </td>
                            <td>{{countryCodeConfiguration.Name}}</td>
                            <td>{{countryCodeConfiguration.Code}}</td>
                            <td>{{countryCodeConfiguration.AG}}</td>
                            <td>{{countryCodeConfiguration.UseCase}}</td>
                        </tr>
                   
                        <tr *ngIf="countryCodeConfiguration.Id === this.successfulData.selected.Id">
                            <td>
                                <img src="assets/img/Add.png" (click)="CountryCodeUpdate(countryCodeConfiguration)" title="Update" />
                                <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                            </td>
                            <td style="display:none;">{{successfulData.selected.Id}}</td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-4%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdCountry" name="grdCountry" [(ngModel)]="successfulData.selected.Name"  >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option  *ngFor="let C of Countries" [ngValue]="C.Country">{{C.Country}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-3%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdCountryCode" name="grdCountryCode" [(ngModel)]="successfulData.selected.Code" (keypress)="validateNumber($event)"  />
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-4%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdAG" name="grdAG" [(ngModel)]="successfulData.selected.AG"  >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option  *ngFor="let AG of AGList" value="{{AG.Value}}">{{AG.Value}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-3%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdUseCase" name="grdUseCase" [(ngModel)]="successfulData.selected.UseCase"  >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option  *ngFor="let UseCase of UseCaseList" value="{{UseCase.Value}}">{{UseCase.Value}}</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td>
                                <button id="btnAddCountryCodeConfiguration" type="button" class="btn btn-default btn-group-sm Button1" (click)="CountryCodeAdd()">
                                    <span class="fa fa-check-circle" aria-hidden="true">
                                    </span> Add
                                </button>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-4%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdfCountry" name="grdfCountry" [(ngModel)]="CountryCodeDetails.Name" aria-labelledby="grdfCountry"  >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option  *ngFor="let C of Countries">{{C.Country}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-3%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfCountryCode" name="grdfCountryCode" [(ngModel)]="CountryCodeDetails.Code" (keypress)="validateNumber($event)"  placeholder="CountryCode" />
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-4%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdfAG" name="grdfAG" [(ngModel)]="CountryCodeDetails.AG" aria-labelledby="grdfAG" >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option  *ngFor="let AG of AGList" value="{{AG.Value}}">{{AG.Value}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-3%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdfUseCase" name="grdfUseCase" [(ngModel)]="CountryCodeDetails.UseCase" aria-labelledby="grdfUseCase" >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option  *ngFor="let UseCase of UseCaseList" value="{{UseCase.Value}}">{{UseCase.Value}}</option>
                                </select>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td colspan="11" style="text-align: center;">
                                <paginator></paginator>
                            </td>
                        </tr> -->
                        <tr>
                            <td colspan="11" style="text-align: center;">
                                <!-- pager -->
                                <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                        </a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                    </li>
                                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                        <a (click)="setPage(page)">{{page}}</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                        <a (click)="setPage(pager.startPage + 5)">...</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                        <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                    </li>
                                    
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tfoot>
                </table>                
            </div>
        </div>

        <div id="AlertForAccess" style="display:none;">
            <div class="row" style="padding-top:-20%">
                <div class="col-sm-12" style="margin-left:5%;">
                    <h4 style="color:red;">
                        Access Not Available.Please refer User Guidelines section for any access or tool issue.
                    </h4>
                </div>
            </div>
        </div>
    </div>
</form>